// extracted by mini-css-extract-plugin
module.exports = {"pagination-wrap":"pagination-wrap-v9kzp","total-count":"total-count-3V7WZ"};